import React from 'react';
import Select from 'react-select';

const SelectDrawers = ({ property, formik }: any) => (
  <div className='flex flex-col justify-between'>
    <h4 className='font-bold mb-3'>Seleccionar Gaveta:</h4>
    <div>
      <Select
        className='w-96 z-20'
        id='form-drawers_id'
        name='drawers_id'
        onChange={(selectedOption) =>
          formik.setFieldValue('drawers_id', selectedOption.value)
        }
        options={[
          { value: '', label: 'Selecciona una gaveta' },
          ...property?.drawers?.map((drawer: any) => ({
            value: drawer.id,
            label: `${drawer.label}${
              drawer.has_key ? ' - Tiene llaves de la propiedad' : ''
            }`,
          })),
        ]}
        styles={{
          option: (styles) => ({
            ...styles,
            padding: '18px 10px',
          }),
        }}
        placeholder='Selecciona una gaveta'
      />

      {formik.errors.drawers_id && (
        <p className='text-red-600 text-sm mt-0.5'>
          {formik.errors.drawers_id}
        </p>
      )}
    </div>
  </div>
);

export default SelectDrawers;
